/**
 * Tracks stable card keys during archive mutations so re-encrypted action ids in stale SSR
 * prefetches cannot resurrect a dismissed card. Fresh API responses remain authoritative.
 */
const transientlyHiddenCardKeys = new Set<string>()

export function registerTransientlyHiddenNextStepCardKey(cardKey: string): void {
    transientlyHiddenCardKeys.add(cardKey)
}

export function unregisterTransientlyHiddenNextStepCardKey(cardKey: string): void {
    transientlyHiddenCardKeys.delete(cardKey)
}

export function isTransientlyHiddenNextStepCardKey(cardKey: string | null | undefined): boolean {
    return typeof cardKey === 'string' && transientlyHiddenCardKeys.has(cardKey)
}

export function filterTransientlyHiddenNextStepCards<T extends { key: string }>(cards: T[]): T[] {
    return cards.filter((card) => !isTransientlyHiddenNextStepCardKey(card.key))
}

/** Test-only reset so examples do not leak transient hide state. */
export function resetTransientlyHiddenNextStepCardKeysForTests(): void {
    transientlyHiddenCardKeys.clear()
}
